<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="620px"
      class="dialog-main"
      :before-close="onBeforeClose"
      :close-on-click-modal="false"
    >
      <el-form
        :model="typeForm"
        :rules="rules"
        ref="typeForm"
        label-width="80px"
        class="demo-form-inline"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="一级分类" prop="materialTopTypeId">
              <el-select
                v-model="typeForm.materialTopTypeId"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in oneOptions"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="二级分类">
              <el-select
                v-model="typeForm.materialMiddleTypeId"
                placeholder="请选择"
                size="mini"
                :disabled="isTopEdit"
              >
                <el-option
                  v-for="item in twoOptions"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="三级分类">
              <el-select
                v-model="typeForm.materialDownTypeId"
                placeholder="请选择"
                size="mini"
                :disabled="isMiddEdit"
              >
                <el-option
                  v-for="item in threeOptions"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序值" prop="orderNo">
              <el-input
                v-model.number="typeForm.orderNo"
                placeholder="请输入排序值"
                size="mini"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="mass-content">
        <el-input
          type="textarea"
          clearable
          v-model="material.content"
          autocomplete="off"
          size="small"
          maxlength="200"
          show-word-limit
        ></el-input>
        <div class="upload-image-wrap">
          <el-upload
            class="upload-demo"
            :multiple="this.currentUploadType == 'img' ? true : false"
            :auto-upload="false"
            :limit="limit"
            action="#"
            :accept="acceptText"
            :on-change="onChange"
            :on-exceed="exceed"
            :on-remove="uploadImageRemove"
            :on-preview="previewImage"
            :file-list="fileList"
          >
            <el-button
              size="small"
              icon="el-icon-plus"
              slot="trigger"
              type="plain"
              :disabled="handleDisabled('img')"
              @click="handleUpload('img')"
              >添加图片</el-button
            >
            <el-button
              size="small"
              icon="el-icon-plus"
              slot="trigger"
              type="plain"
              :disabled="handleDisabled('mp4')"
              @click="handleUpload('mp4')"
              >添加视频</el-button
            >
            <el-button
              size="small"
              icon="el-icon-plus"
              slot="trigger"
              type="plain"
              :disabled="handleDisabled('file')"
              @click="handleUpload('file')"
              >上传文档</el-button
            >
            <el-button
              size="small"
              style="margin-left: 10px"
              icon="el-icon-plus"
              type="plain"
              :disabled="handleDisabled('link')"
              @click="handleSetingLint('link')"
              >设置链接</el-button
            >
            <p
              style="color: #9f9fb8; display: block;font-size: 12px;margin-top: 4px;"
            >
              *温馨提示：
              <br />
              1 选择素材时，只能选择其中一种；
              <br />
              2 建议图片大小不超过2M，格式为jpg、png；
              <br />
              3 视频大小不超过10M，格式为mp4；
              <br />
              4 文档大小不超过20M，格式为doc、xlsx、xls、ppt、pdf；
            </p>
            <!-- <el-button
              size="small"
              style="margin-left: 10px;"
              icon="el-icon-plus"
              type="plain"
              v-show="!hideUpload"
              @click="handleSeeData"
              >查看数据格式video</el-button
            > -->
          </el-upload>
          <!-- 链接的展示 -->
          <div class="link-wrap" v-if="linkList.length != 0">
            <div class="link-item">
              <div class="item-left">
                <div class="title">{{ myFormLink.title }}</div>
                <div class="content" v-if="myType != 3">
                  {{ myFormLink.content }}
                </div>
              </div>
              <div class="item-right">
                <!-- 查看图片 -->
                <!-- @click="previewImage(myFormLink.fileFullUrl)" -->
                <el-image
                  v-if="myFormLink.pictureUrl"
                  class="photo"
                  :src="myFormLink.fileFullUrl"
                >
                </el-image>
              </div>
              <div class="close-wrap" @click="deletePhoto">
                <span class="el-icon-close close-icon"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="onBeforeClose('取消')"
          style="margin-right: 20px"
          >取 消</el-button
        >
        <el-button type="primary" size="small" @click="determine"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 离开确认提示对话框 -->
    <ConfirmTipDialog
      ref="confirmTipDialog"
      @levelconfirm="levelconfirm"
    ></ConfirmTipDialog>
    <SaveErrorTIp ref="saveErrorTIp" />
    <!-- 视频查看 -->
    <!-- 视频预览 -->
    <el-dialog
      class="video-dialog"
      :visible.sync="videoShow"
      width="400px"
      style="margin-top: 0vh"
      close-on-click-modal
      append-to-body
    >
      <video
        width="100%"
        height="auto"
        v-if="fileList.length != 0"
        controls="controls"
      >
        <source :src="videoUrl" type="video/mp4" />
      </video>
    </el-dialog>
    <!-- 插入链接 -->
    <NewLink ref="newLink" @comfirm="linkComfirm"></NewLink>
  </div>
</template>

<script>
// 新建素材、修改素材的弹层
import ConfirmTipDialog from "./confirmTipDialog.vue";
import SaveErrorTIp from "./saveErrorTIp.vue";
// 插入链接
import NewLink from "@/views/mass/SOP/components/newLink.vue";

import { saveMaterial, updateMaterial, savefile } from "@/api/mass/mass.js";
export default {
  props: {
    emitTypeList: {
      type: Array,
      default: [],
    },
  },
  components: {
    ConfirmTipDialog,
    SaveErrorTIp,
    NewLink,
  },
  data() {
    return {
      confirmFlag: false, //  修改是否确认
      hideUpload: false,
      limit: 9,
      title: "",
      dialogVisible: false, //对话框显示与否
      // 新建/编辑素材中的结构体
      material: {
        content: "",
        chatMaterialResources: [],
        chatMaterialLink: {},
      },
      typeForm: {
        materialTopTypeId: "",
        materialMiddleTypeId: "",
        materialDownTypeId: "",
        orderNo: 0,
      },
      oneOptions: [],
      twoOptions: [],
      threeOptions: [],
      oldObject: {},
      fileList: [],
      oldFileList: [],
      previewUrl: "", // 当前的图片预览地址
      notUploaded: [],
      uploaded: [],
      uploadType: "",
      videoShow: false,
      videoUrl: "",
      // 设置链接
      linkList: [],
      myFormLink: {
        title: "",
        httpUrl: "",
        content: "",
        pictureUrl: "",
        pictureName: "",
        fileFullUrl: "",
      },
      myType: 0,
      acceptText: ".jpg,.jpeg,.png,.JPG,.JPEG,.PBG,",
      rules: {
        materialTopTypeId: [
          { required: true, message: "请选择一级分类", trigger: "change" },
        ],
        orderNo: [
          { required: true, message: "请输入排序值", trigger: "blur" },
          {
            pattern: /^\d{1,4}$/,
            message: "排序值必须为0-9999的数字",
            trigger: "blur",
          },
        ],
      },
      newTypeList: [],
      isTopinit: false,
      isMiddinit: false,
      isTopEdit: true,
      isMiddEdit: true,
      currentUploadType: "",
    };
  },
  watch: {
    emitTypeList: {
      handler(newVal) {
        if (!Array.isArray(newVal) || newVal.length <= 0) return;
        this.newTypeList = [];
        this.oneOptions = newVal[0];
        this.twoOptions = newVal[1];
        this.threeOptions = newVal[2];
      },
      deep: true,
      immediate: true,
    },
    "typeForm.materialTopTypeId": {
      handler(newVal) {
        if (newVal) {
          const typeList = this.oneOptions.find((item) => item.id == newVal);
          if (!typeList) return;
          if (
            Array.isArray(typeList.children) &&
            typeList.children.length > 0
          ) {
            this.filterType(typeList.children, 1);
          } else {
            this.$nextTick(() => {
              this.twoOptions = [];
              this.threeOptions = [];
            });
          }
          this.isTopEdit = false;
        } else {
          this.oneOptions = this.emitTypeList[0];
          this.twoOptions = this.emitTypeList[1];
          this.threeOptions = this.emitTypeList[2];
          this.isTopEdit = true;
        }
        if (this.isTopinit) {
          this.isTopinit = false;
          this.isMiddinit = true;
          return;
        }
        this.$set(this.typeForm, "materialMiddleTypeId", "");
        this.$set(this.typeForm, "materialDownTypeId", "");
      },
      deep: true,
    },
    "typeForm.materialMiddleTypeId": {
      handler(newVal) {
        if (newVal) {
          const typeList = this.twoOptions.find((item) => item.id == newVal);
          if (!typeList) return;
          if (
            Array.isArray(typeList.children) &&
            typeList.children.length > 0
          ) {
            this.filterType(typeList.children, 2);
          } else {
            this.$nextTick(() => {
              this.threeOptions = [];
            });
          }
          this.isMiddEdit = false;
        } else {
          this.oneOptions = this.emitTypeList[0];
          this.twoOptions = this.emitTypeList[1];
          this.threeOptions = this.emitTypeList[2];
          this.isMiddEdit = true;
        }
        if (this.isMiddinit) {
          return (this.isMiddinit = false);
        }
        this.$set(this.typeForm, "materialDownTypeId", "");
      },
      deep: true,
    },
  },
  methods: {
    init() {
      this.linkList = [];
      this.myFormLink.title = "";
      this.myFormLink.httpUrl = "";
      this.myFormLink.content = "";
      this.myFormLink.pictureUrl = "";
      this.myFormLink.pictureName = "";
      this.myFormLink.fileFullUrl = "";
      this.typeForm.materialTopTypeId = "";
      this.typeForm.materialMiddleTypeId = "";
      this.typeForm.materialDownTypeId = "";
      this.typeForm.orderNo = 0;
      this.fileList = [];
      this.oldFileList = [];
      this.material.id = "";
      this.material.content = "";
      this.material.chatMaterialResources = [];
      this.material.chatMaterialLink = {};
      this.$nextTick(() => {
        this.$refs["typeForm"].resetFields();
      });
    },
    // 过滤分类条件
    filterType(typeList, level) {
      this.newTypeList = [];
      if (level == 1) {
        const twoOptions = [],
          threeOptions = [];
        this.recursiveMap(typeList, this.newTypeList, 2);
        this.newTypeList.forEach((options) => {
          if (options.level == 2) {
            twoOptions.push(options.item);
          } else {
            threeOptions.push(options.item);
          }
        });
        this.$nextTick(() => {
          this.twoOptions = [...twoOptions];
          this.threeOptions = [...threeOptions];
        });
      } else {
        this.$nextTick(() => {
          this.threeOptions = [...typeList];
        });
      }
    },
    recursiveMap(nestedList, newList, level = 1) {
      nestedList.forEach((item) => {
        newList.push({ item, level });
        if (Array.isArray(item.children) && item.children.length > 0) {
          this.recursiveMap(item.children, newList, level + 1);
        }
      });
    },
    // 上传链接
    handleSetingLint(text) {
      console.log("上传链接12312");
      this.$refs.newLink.show(this.myFormLink, this.myType);
      this.uploadType = text;
    },
    // 链接新建
    linkComfirm(form) {
      this.linkList = [];
      this.type = 2;
      this.myFormLink = form;
      this.linkList.push(this.myFormLink);
      // this.submitTO()
      console.log("新加入的链接XXXXX", this.material, form);
      this.material.chatMaterialLink = {
        title: form.title, //链接标题
        content: form.content, //使用场景
        httpUrl: form.httpUrl, //链接地址
        pictureUrl: form.pictureUrl, //链接图片地址
        pictureName: form.pictureName, //链接图片名
        pictureFullUrl: form.fileFullUrl,
      };
    },
    // 删除链接
    deletePhoto() {
      this.myFormLink.title = "";
      this.myFormLink.httpUrl = "";
      this.myFormLink.content = "";
      this.myFormLink.pictureUrl = "";
      this.myFormLink.pictureName = "";
      this.myFormLink.fileFullUrl = "";
      this.linkList = [];
      this.material.chatMaterialLink = {};
    },
    // 查看数据格式
    handleSeeData() {
      console.log(
        "cutPicture",
        this.cutPicture(
          "http://36.137.14.25:9090/wecom/wpHiy3CAAAJEpISih4OQ4Pw95UHKo8sg/2023/04/06/f4fc7d38-fa22-4217-90c5-cd95606d7369.mp4",
        ),
      );
    },
    // 获取视频的第一帧作为图片展示
    cutPicture(videoUrl) {
      let imgUrl = { url: "" };
      //这里的item是列表的每一项
      let video = document.createElement("video");
      video.style = "position:fixed; top: 9999px;left:9999px;z-index:-9999";
      video.preload = "metadata";
      video.currentTime = 1; //截取的视频第一秒作为图片
      video.src = videoUrl;
      video.setAttribute("crossOrigin", "anonymous");
      video.width = 113;
      video.height = 75;
      document.body.appendChild(video);
      video.onloadeddata = function() {
        let canvas = document.createElement("canvas");
        canvas.width = 113;
        canvas.height = 75;
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
        var oGrayImg = canvas.toDataURL("image/jpeg");
        imgUrl.url = oGrayImg; //这里输出的imgUrl就是视频的封面图
        console.log("----------", imgUrl, oGrayImg);
        // this.remove();
      };
      return imgUrl;
    },
    handleUpload(text) {
      this.currentUploadType = text;
      console.log("上传xxxx文件", text);
      this.uploadType = text;
      if (text == "img") {
        this.limit = 9;
        this.acceptText = ".jpg,.jpeg,.png,.JPG,.JPEG,.PBG,";
      }
      if (text == "file") {
        this.limit = 1;
        this.acceptText = ".doc,.xlsx,.xls,.ppt,.pdf";
      }
      if (text == "mp4") {
        this.limit = 1;
        this.acceptText = ".MP4,.mp4";
      }
    },
    handleDisabled(type) {
      if (this.fileList <= 0 && this.linkList <= 0) {
        return false;
      } else {
        console.log("XXXXX---视频路径", this.myFormLink.httpUrl);
        if (
          this.uploadType === type &&
          this.fileList.length < this.limit &&
          this.myFormLink.httpUrl.length <= 0
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    // 开启素材操作失败提示框
    showTip(title, content) {
      this.$refs.saveErrorTIp.show(title, content);
    },
    // 离开确认弹层的取消事件（离开此页）
    levelconfirm() {
      this.dialogVisible = false;
    },
    onBeforeClose(done) {
      if (this.confirmFlag) {
        // 点击确认时关闭弹窗
        done();
      } else {
        let flag =
          this.oldObject.content === this.material.content &&
          JSON.stringify(this.oldFileList) === JSON.stringify(this.fileList);
        if (flag) {
          if (done == "取消") {
            this.dialogVisible = false;
          } else {
            done();
          }
        } else {
          // 取消确认时阻止关闭弹窗
          if (done == "取消") {
          } else {
            done(false);
          }
          this.$refs.confirmTipDialog.open();
        }
      }
      this.makeParam = {};
    },
    show(title, data) {
      this.fileList = [];
      this.oldFileList = []; // 判断是否更改时使用
      this.linkList = [];
      this.myFormLink.title = "";
      this.myFormLink.httpUrl = "";
      this.myFormLink.content = "";
      this.myFormLink.pictureUrl = "";
      this.myFormLink.pictureName = "";
      this.myFormLink.fileFullUrl = "";
      this.typeForm.materialTopTypeId = "";
      this.typeForm.materialMiddleTypeId = "";
      this.typeForm.materialDownTypeId = "";
      this.typeForm.orderNo = 0;
      this.title = title;
      this.initParams();
      if (title == "修改素材") {
        this.editInit(data);
      }
      this.confirmFlag = false;
      this.oldObject = JSON.parse(JSON.stringify(this.material));
      this.dialogVisible = true;
    },
    initParams() {
      this.material.content = "";
      this.material.chatMaterialResources = [];
    },
    // 类型为修改时，初始所需的操作
    editInit(row) {
      this.isTopinit = true;
      let data = row;
      let updataDataParam = {};
      // 传入初始数据
      updataDataParam.content = data.content;
      updataDataParam.id = data.id;
      updataDataParam.chatMaterialResources = data.chatMaterialResources;
      updataDataParam.chatMaterialLink = data.chatMaterialLink;
      this.typeForm.materialTopTypeId = data.materialTopTypeId;
      this.typeForm.materialMiddleTypeId = data.materialMiddleTypeId;
      this.typeForm.materialDownTypeId = data.materialDownTypeId;
      this.typeForm.orderNo = data.orderNo != null ? data.orderNo : 0;
      console.log("传入的初始化数据XXX", data, updataDataParam);
      if (data.chatMaterialResources.length > 0) {
        this.uploadType = data.chatMaterialResources[0].type;
      } else if (data.chatMaterialLink && data.chatMaterialLink.httpUrl) {
        this.uploadType = "link";
        this.myFormLink.title = data.chatMaterialLink.title;
        this.myFormLink.httpUrl = data.chatMaterialLink.httpUrl;
        this.myFormLink.content = data.chatMaterialLink.content;
        this.myFormLink.pictureUrl = data.chatMaterialLink.pictureUrl;
        this.myFormLink.pictureName = data.chatMaterialLink.pictureName;
        this.myFormLink.fileFullUrl = data.chatMaterialLink.pictureFullUrl;
        this.linkList.push(this.myFormLink);
        console.log("muformLink", this.myFormLink);
      }

      updataDataParam.chatMaterialResources.forEach((item) => {
        let obj = {
          name: item.fileName,
          url: item.url,
          fileFullUrl: item.fileFullUrl,
          type: this.uploadType,
        };
        this.fileList.push(obj);
      });
      this.oldFileList = JSON.parse(JSON.stringify(this.fileList));
      this.hideUpload = this.fileList.length >= this.limit;
      this.material = JSON.parse(JSON.stringify(updataDataParam));
    },
    //  上传图片超出9张时的钩子
    exceed(val) {
      console.log(123456, val);
      if (this.currentUploadType == "img") {
        this.$message.error("最多只能上传9张图片");
      }
    },
    // 文件状态改变时的钩子
    onChange(file, fileList) {
      this.hideUpload = fileList.length >= this.limit;
      let flag = this.isCorrecFile(file);
      if (!flag) {
        fileList.pop();
      }
      this.fileList = fileList;
      console.log("查看上传文件类型XXXX", file, this.fileList);
    },
    // 检查文件合法性
    isCorrecFile(file) {
      if (this.uploadType === "img") {
        const isJPG = file.raw.type === "image/jpeg";
        const isPNG = file.raw.type === "image/png";
        const isPG = isJPG || isPNG; // 限制图片格式为jpg / png
        const isLt2M = file.size / 1024 / 1024 < 2; // 限制图片大小
        if (!isPG) {
          this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
        }
        return isPG && isLt2M;
      } else if (this.uploadType === "file") {
        console.log("file-------", file);
        const isLt2M = file.size / 1024 / 1024 < 20; // 限制大小
        const isFile =
          [
            "application/msword",
            "application/vnd.ms-excel",
            "application/ppt",
            "application/pdf",
            "application/vnd.ms-powerpoint",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          ].indexOf(file.raw.type) != -1;
        if (!isFile) {
          this.$message.error(
            "上传文档的格式只能是 doc、excel、ppt、pdf 格式!",
          );
        }
        if (!isLt2M) {
          this.$message.error("上传文档大小不能超过 20MB!");
        }
        return isFile && isLt2M;
      } else if (this.uploadType === "mp4") {
        const isJPG = file.raw.type === "video/mp4";
        const isPNG = file.raw.type === "video/MP4";
        const isPG = isJPG || isPNG; // 限制图片格式为jpg / png
        const isLt2M = file.size / 1024 / 1024 < 10; // 限制图片大小
        if (!isPG) {
          this.$message.error("上传视频只能是 MP4 或 mp4 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传视频大小不能超过 10MB!");
        }
        return isPG && isLt2M;
      }
    },
    // 上传的图片移除， file： 移除的当前项；flieList： 移除后的文件列表
    uploadImageRemove(file, fileList) {
      // 编辑的移除操作
      let name = file.name;
      let index = this.material.chatMaterialResources.findIndex((current) => {
        return current.fileName === name;
      });
      if (index != -1) {
        this.material.chatMaterialResources.splice(index, 1);
      }
      this.fileList = fileList;
    },
    // 预览上传的图片
    previewImage(file) {
      if (this.uploadType === "img") {
        let url = null;
        if (!file.fileFullUrl) {
          if (window.createObjectURL != undefined) {
            url = window.createObjectURL(file.raw);
          } else if (window.URL != undefined) {
            url = window.URL.createObjectURL(file.raw);
          } else if (window.webkitURL != undefined) {
            url = window.webkitURL.createObjectURL(file.raw);
          }
        } else {
          url = file.fileFullUrl;
        }
        this.$emit("preView", url);
      } else if (file.name.indexOf("mp4") !== -1) {
        this.videoShow = true;
        this.videoUrl = file.fileFullUrl;
      } else {
        this.$message.warning("不可查看");
        console.log("查看内容的形式XXXX", file);
      }
    },
    // 新建/修改 素材确定按钮
    determine() {
      this.$refs["typeForm"].validate((valid) => {
        if (valid) {
          // 分类入参调整
          const foundItems = [
            this.oneOptions.find(
              (item) => item.id == this.typeForm.materialTopTypeId,
            ),
            this.twoOptions.find(
              (item) => item.id == this.typeForm.materialMiddleTypeId,
            ),
            this.threeOptions.find(
              (item) => item.id == this.typeForm.materialDownTypeId,
            ),
          ];
          this.material.chatMaterialTypes = foundItems
            .map((item, level) => ({
              id: item?.id || null,
              level: item?.level || null,
            }))
            .filter((item) => item.id !== null);
          this.material.orderNo = this.typeForm.orderNo;

          // 修改
          if (
            !this.material.content &&
            this.fileList.length == 0 &&
            this.myFormLink.httpUrl.length <= 0
          ) {
            this.$message.error("字段/文件不可为空，请重试！");
          } else {
            if (this.fileList.length != 0) {
              this.notUploaded = [];
              this.uploaded = [];
              this.fileList.forEach((item) => {
                if (item.fileFullUrl) {
                  this.uploaded.push(item);
                } else {
                  this.notUploaded.push(item);
                }
              });
              let formData = new FormData();
              this.notUploaded.forEach((file) => {
                //所有文件保存在formData中
                console.log("----------");
                formData.append("file", file.raw);
              });
              if (this.notUploaded.length == 0) {
                // 发送表单
                this.submitForm();
              } else {
                //请求批量上传接口
                this.upLoadImage(formData);
              }
            } else {
              // 发送表单
              this.submitForm();
            }
          }
        } else {
          return false;
        }
      });
    },
    // 上传文件
    upLoadImage(formData) {
      savefile(formData, localStorage.getItem("Authorization")).then((res) => {
        if (res.error.code == 200) {
          let imgArr = [];
          res.data.forEach((item) => {
            let obj = {
              fileName: item.name,
              url: item.url,
              type: this.uploadType,
            };
            imgArr.push(obj);
          });
          this.material.chatMaterialResources = [
            ...this.material.chatMaterialResources,
            ...imgArr,
          ];
          // 发送表单
          this.submitForm();
        } else {
          // this.$message({
          //   type: 'info',
          //   message: res.error.message
          // });
          this.showTip(this.title + "失败", res.error.message);
        }
      });
    },
    // 发送表单
    submitForm() {
      if (this.title === "新建素材") {
        // 1.新建保存
        this.saveMaterial(this.material);
      } else {
        // 2.修改保存
        this.updateMaterial(this.material);
      }
    },
    // 保存素材
    saveMaterial(params) {
      let that = this;
      saveMaterial(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.$message({
              type: "success",
              message: "保存成功!",
            });
            // 关闭弹窗
            this.confirmFlag = true;
            that.dialogVisible = false;
            // 刷新数据
            this.$emit("reGet", "新建");
          } else {
            this.showTip("新建素材失败", res.error.message);
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    },
    // 修改素材
    updateMaterial(params) {
      let that = this;
      updateMaterial(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            that.$message({
              type: "success",
              message: "修改成功！!",
            });
            this.confirmFlag = true;
            that.dialogVisible = false;
            this.$emit("reGet", "修改");
          } else {
            this.showTip("修改素材失败", res.error.message);
          }
        })
        .catch((err) => {
          console.log(err, "errr");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-main {
  /deep/ .el-dialog {
    min-height: 350px;
  }

  /deep/ .el-dialog__body {
    margin: 20px 20px 0px 20px;
    padding: 0px;
    min-height: 230px;
  }

  /deep/ .el-dialog__footer {
    text-align: right;
  }

  .mass-content {
    border: 1px solid #c0c4cc;
    border-radius: 5px;

    /deep/ .el-textarea__inner {
      border: 0px !important; //改成0，边框就消失了！
      resize: none !important;
      min-height: 180px !important;
    }

    .upload-image-wrap {
      margin: 0 5px;
      padding: 8px 0;
      border-top: 1px solid #c0c4cc;
    }
  }
}

.label {
  padding: 0 12px 0 0;
}

.video-dialog {
  .el-dialog {
    box-shadow: unset;
    width: 100%;
    background-color: unset;
    margin-top: 7vh !important;

    .el-dialog__headerbtn {
      display: none;
    }

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 0;
      display: flex;
      justify-content: center;
      background-color: transparent;
    }
  }
}

.link-wrap {
  margin-top: 45px;
  display: flex;

  .link-item {
    background: #f9f9f9;
    padding: 9px 9px 9px 11px;
    display: flex;
    align-items: center;
    position: relative;

    .item-left {
      width: 163px;
      margin-right: 26px;

      .title {
        font-weight: 600;
        font-size: 14px;
        letter-spacing: -0.01px;
        color: #666666;
        margin-bottom: 4px;
      }

      .content {
        font-weight: 400;
        font-size: 10px;
        line-height: 16px;
        letter-spacing: -0.01px;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box; //作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
        -webkit-line-clamp: 2; //显示的行
      }
    }

    .item-right {
      width: 55px;
      height: 53px;
      cursor: pointer;

      .photo {
        height: 100%;
        width: 100%;
      }
    }

    .close-wrap {
      position: absolute;
      top: -6px;
      right: -6px;
      border-radius: 50%;
      width: 13px;
      height: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      cursor: pointer;
      background-color: #ff5e6a;

      .close-icon {
        color: white;
      }
    }
  }
}
</style>
